import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class YtService {
  apiKey = 'AIzaSyAhrjrY8eAaG6up3FYzMBJMinxTGAjjpQ0';

  constructor(public http: HttpClient) {}

  getchannelProfilePicture(channel) {
    return this.http.get(
      'https://www.googleapis.com/youtube/v3/channels?part=snippet&id=' +
        channel +
        '&fields=items%2Fsnippet%2Fthumbnails&key=' +
        this.apiKey
    );
  }

  getPlaylistsForChannel(channel) {
    return this.http.get(
      'https://www.googleapis.com/youtube/v3/playlists?key=' +
        this.apiKey +
        '&channelId=' +
        channel +
        '&part=snippet,id&maxResults=1'
    );
  }

  getListVideos(listId) {
    return this.http.get(
      'https://www.googleapis.com/youtube/v3/playlistItems?key=' +
        this.apiKey +
        '&playlistId=' +
        listId +
        '&part=snippet,id&maxResults=4'
    );
  }
}
